import { ActionTree } from "vuex";
import * as types from "@/store/constants/types";
import { getAppVersion, isIos } from "@/utils/lodash";
import Http from "@/api/http/fetch/index";
import { judgeVersion } from "@/utils/judgeVersion";
import generalUtilsHelper from "@/utils/generalUtils";
import { sendEvent, sendEventWithParams } from "@/utils/analytics";
import { getPureSuperPayConfig } from "@/api/http/gx/gxPinAd";
import SuperPayAndBackUpHelpers, {
  TEMP_KEY,
  LOCAL_KEY
} from "@/utils/superPayAndBackUp";

const actions: ActionTree<any, any> = {
  async [types.CHECK_SUPER_PAY_APP_CAN_SHOW](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    //判断是否可用于显示app：
    try {
      //判断原生请求superpay的接口是否可用
      //superpay的请求由web来发，所以没有版本兼容问题
      const checkConfigEnable = await dispatch(
        types.CHECK_SUPER_PAY_APP_CONFIG_ENABLE
      );
      console.log("checkConfigEnable:", checkConfigEnable);
      if (checkConfigEnable) {
        //拉取更新配置：
        const superPayAppConfig = await dispatch(
          types.REQUEST_SUPER_PAY_APP_CONFIG
        );
        //检查是否安装了app:
        const checkSuperPayAppInstalled = await dispatch(
          types.CHECK_SUPER_PAY_APP_INSTALLED,
          superPayAppConfig
        );
        if (checkSuperPayAppInstalled) {
          commit(types.UPDATE_SUPER_PAY_SHOW_ENABLE, false);
          return false; //如果已经装了
        } else {
          //最后判断是否在setting有配字段：
          //判断是否有super_pay的字段
          if (
            getters[types.GETTER_SUPER_PAY_SETTING_PARAMS_VALID] &&
            getters[types.GETTER_SUPER_PAY_APP_SHOW_OTHER_CONDITION]()
          ) {
            // dispatch(types.SHOW_SUPER_PAY_BUBBLE);
            commit(types.UPDATE_SUPER_PAY_SHOW_ENABLE, true);
            return true;
          } else {
            commit(types.UPDATE_SUPER_PAY_SHOW_ENABLE, false);
            return false;
          }
        }
      } else {
        commit(types.UPDATE_SUPER_PAY_SHOW_ENABLE, false);
        return false;
      }
    } catch (error) {
      console.log("CHECK_SUPER_PAY_APP_CAN_SHOW error:", error);
      return false;
    }
  },
  async [types.SWITCH_FRONT_BACK_TO_CHECK_SUPER_PAY_INSTALL_STATUS](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    const checkSuperPayAppInstallProcess = async () => {
      const checkSuperPayAppInstalledResult = await dispatch(
        types.CHECK_SUPER_PAY_APP_INSTALLED,
        getters[types.GETTER_SUPER_PAY_APP_CONFIG]
      );
      if (checkSuperPayAppInstalledResult) {
        //如果安装了
        commit(types.UPDATE_SUPER_PAY_SHOW_ENABLE, false); //隐藏推荐
        //从feed中替换super feed：
        commit(types.REPLACE_SUPER_PAY_OFFER_FEED);
      } else {
        //如果没有安装，再次显示:
        //需要达到达到其的条件：setting 接口可用 达到其他条件：
        if (
          getters[types.GETTER_SUPER_PAY_SETTING_PARAMS_VALID] &&
          getters[types.GETTER_SUPER_PAY_APP_SHOW_OTHER_CONDITION]()
        ) {
          commit(types.UPDATE_SUPER_PAY_SHOW_ENABLE, true); //显示推荐
        }
        //再次拉取appCoinfig:
        dispatch(types.REQUEST_SUPER_PAY_APP_CONFIG);
      }
    };

    if (getters[types.GETTER_SUPER_PAY_SHOW_ENABLE]) {
      //如果显示中:
      checkSuperPayAppInstallProcess();
    } else {
      //如果没有显示,检查是否拉到了superPayAppCoinfig，检测是否需要再次显示：
      if (
        getters[types.GETTER_SUPER_PAY_APP_CONFIG] &&
        getters[types.GETTER_SUPER_PAY_APP_CONFIG_INTERFACE_ENABLE]
      ) {
        checkSuperPayAppInstallProcess();
      }
    }
  },
  async [types.CHECK_SUPER_PAY_WAY_CAN_USE](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    //判断是否可用于显示app：
    try {
      const appInfo: any = await Http.AppInfo();
      const userAgent = getAppVersion();
      console.log("userAgent", userAgent);
      let versionNew: any = false;
      if (isIos()) {
        versionNew =
          appInfo &&
          appInfo.CODE_VERSION &&
          judgeVersion(appInfo.CODE_VERSION, "4.4.0");
      } else {
        versionNew = judgeVersion(userAgent, "4.4.0");
      }
      commit(types.UPDATE_SUPER_PAY_WAY_INTERFACE_ENABLE, versionNew);
      if (versionNew) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  },
  async [types.CHECK_PRODUCT_IAP_VALID](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      //先check接口是否可用:
      const appInfo: any = await Http.AppInfo();
      let versionNew: any = false;
      versionNew =
        appInfo &&
        appInfo.CODE_VERSION &&
        judgeVersion(appInfo.CODE_VERSION, "4.4.0");
      if (versionNew) {
        const IapProductValidResult = await Http.IapProductValid(payload);
        console.log("IapProductValidResult:", IapProductValidResult);
        if (IapProductValidResult === "invalid") {
          return false;
        } else {
          return true;
        }
      } else {
        //老版本的用本地化价格去判断：(本地化价格已经不准确了，默认合法)
        return true;
      }
    } catch (error) {
      return true;
    }
  },
  async [types.SHOW_SUPER_PAY_BUBBLE](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    const lastDate = getters[types.GETTER_SUPER_PAY_BUBBLE_SHOW_DATE];
    const lastClick = getters[types.GETTER_SUPER_PAY_BUBBLE_CLICK];
    if (lastDate === null || lastDate === undefined) {
      console.log("isEmpty:", new Date().getDate());
      commit(types.UPDATE_SUPER_PAY_BUBBLE_SHOW_DATE, new Date().getDate());
      commit(types.UPDATE_SUPER_PAY_BUBBLE_STATUS, true);
    } else {
      //比较是否不同：
      if (lastDate !== new Date().getDate()) {
        console.log("比较是否不同：", new Date().getDate());
        commit(types.UPDATE_SUPER_PAY_BUBBLE_SHOW_DATE, new Date().getDate());
        commit(types.UPDATE_SUPER_PAY_BUBBLE_STATUS, true);
        commit(types.UPDATE_SUPER_PAY_BUBBLE_CLICK_STATUS, false);
        sendEvent("uia_superapp_recommend_show", "tab4_bubble");
      } else {
        if (lastClick) {
          commit(types.UPDATE_SUPER_PAY_BUBBLE_STATUS, false); //关闭bubble
        } else {
          sendEvent("uia_superapp_recommend_show", "tab4_bubble");
          commit(types.UPDATE_SUPER_PAY_BUBBLE_STATUS, true);
        }
      }
    }
  },
  async [types.START_INSTALL_SUPER_PAY_APP](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      // 如果当前app已下架， 调用转移接口
      const appTakeDown = getters[types.GETTER_APP_TAKE_DOWN];
      if (appTakeDown) {
        dispatch(types.TRANSFER_MASTER_ID_TO_IDFA);
      }

      const superPayAppConfig = getters[types.GETTER_SUPER_PAY_APP_CONFIG];
      const superPayParams = getters[types.GETTER_SUPER_PAY_PARAMS];

      Http.ADConnect(); //安卓说要频繁调用

      const noRewardProcess = () => {
        Http.StartNewWebInstance(superPayAppConfig.downloadUrl);
      };

      noRewardProcess(); //superpay默认执行不奖励流程

      //点击打点
      if (payload && payload.ga) {
        sendEventWithParams("uia_recommend_app_click", {
          super_pay: payload.ga
        });

        //存储ga变量
        SuperPayAndBackUpHelpers.setLocalKeyTimes(
          LOCAL_KEY.SUPER_PAY_INSTALL_TMEP_KEY,
          payload.ga
        );
      }
    } catch (error) {}
  },
  async [types.REQUEST_SUPER_PAY_APP_CONFIG](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      const superPayAppConfig: any = await getPureSuperPayConfig();
      console.log("获取到superPayAppConfig:", superPayAppConfig);

      commit(types.UPDATE_SUPER_PAY_APP_CONFIG, superPayAppConfig);
      return superPayAppConfig;
    } catch (error) {
      commit(types.UPDATE_SUPER_PAY_SHOW_ENABLE, false);
      return Promise.reject(error);
    }
  },
  async [types.CHECK_SUPER_PAY_APP_INSTALLED](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      const installed = await dispatch(
        types.REQUEST_APP_STATE,
        payload.packageName
      );
      console.log("super pay installed：", installed);

      //打点：
      if (installed) {
        sendEvent("uia_superapp_install_success");
        if (!getters[types.GETTER_SUPER_PAY_APP_INSTALLED_STATUS]) {
          console.log("如果从未安装到安装，进行打点：");
          const ga = SuperPayAndBackUpHelpers.getLocalKeyTimes(
            LOCAL_KEY.SUPER_PAY_INSTALL_TMEP_KEY
          );
          sendEventWithParams("uia_recommend_app_installed", {
            super_pay: ga
          });
        }
      }
      commit(types.UPDATE_SUPER_PAY_APP_INSTALLED_STATUS, installed);
      return installed;
    } catch (error) {
      return true; //让其不显示
    }
  },
  async [types.CHECK_SUPER_PAY_APP_CONFIG_ENABLE](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    //判断是否可用于显示app：//请求是web发的 所以各个版本都可以用
    try {
      const appInfo: any = await Http.AppInfo();
      const userAgent = getAppVersion();
      console.log("userAgent", userAgent);
      let versionNew: any = false;
      if (isIos()) {
        versionNew =
          appInfo &&
          appInfo.CODE_VERSION &&
          judgeVersion(appInfo.CODE_VERSION, "4.4.0");
      } else {
        versionNew = judgeVersion(userAgent, "4.4.0");
      }
      commit(types.UPDATE_SUPER_PAY_APP_CONFIG_INTERFACE_ENABLE, versionNew);
      if (versionNew) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  }
};

export default actions;
